import { createRoute } from '@backoffice-frontend/common'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { useUserHasAccess } from '@backoffice-frontend/restricted'
import { StopNetworkAreaRoutes } from '@backoffice-frontend/sam-common'
import { useGlobalServiceAreaIds } from '@backoffice-frontend/service-area-picker'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { NetworkIcon } from '@moia-dev/pace-icons'

export const StopNetworkAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  const [{ id: globalServiceAreaId }] = useGlobalServiceAreaIds()
  const hasStopNetworkDashboardAccess = useUserHasAccess({
    requiredRights: [BoumRight.STOP_NETWORK_DASHBOARD_R],
  })
  const overviewRoute = globalServiceAreaId
    ? createRoute(StopNetworkAreaRoutes.Show.Overview.route, {
        serviceAreaId: globalServiceAreaId,
      })
    : StopNetworkAreaRoutes.Show.Overview.route
  const stopNetworkRoute = globalServiceAreaId
    ? createRoute(StopNetworkAreaRoutes.Show.route, {
        serviceAreaId: globalServiceAreaId,
      })
    : StopNetworkAreaRoutes.route
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={hasStopNetworkDashboardAccess ? overviewRoute : stopNetworkRoute}
      Icon={NetworkIcon}
    />
  )
}
